/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ClearableSearchField } from "components/SearchField/SearchField";
import HelpIcon from "@mui/icons-material/Help";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgedReceivables } from "utils/api";
import { appConstants } from "utils/appConstants";
import { formatCurrencyAUD } from "utils/formatCurrency";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};

function AgedReceivables() {
  let currency = useSelector((state) => state.currency.currencySymbol);
  const [rows, setRows] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [resetClicked, setResetClicked] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const dispatch = useDispatch();
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [screenAccess, setScreenAccess] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [title, setTitle] = useState("");

  const [selectedDate, setSelectedDate] = useState();

  const nextFieldRef = useRef(null);

  const [values, setValues] = useState({
    duration: "Today",
    sortingType: "",
    sortingField: "",
    customDate: "",
    agingBy: "dueDate",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: [
      "customDate",
      "contactName",
      "lessThanOneMonthTotalAmountToString",
      "moreThanOneMonthTotalAmountToString",
      "moreThanTwoMonthTotalAmountToString",
      "olderThanThreeMonthTotalAmountToString",
      "olderThanThreeMonthTotalAmountToString",
      "lessThanOneMonthTotalAmount",
      "moreThanOneMonthTotalAmount",
      "moreThanTwoMonthTotalAmount",
      "moreThanThreeMonthTotalAmount",
      "olderThanThreeMonthTotalAmount",
      "totalAmount",
      "duration",
      "agingBy",
    ],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });

  const headers = [
    { label: "Contact Name", key: "contactName" },
    { label: "< 1 Month", key: "lessThanOneMonthTotalAmount" },
    { label: "1 Month", key: "moreThanOneMonthTotalAmount" },
    { label: "2 Months", key: "moreThanTwoMonthTotalAmount" },
    { label: "3 Months", key: "moreThanThreeMonthTotalAmount" },
    { label: "Older", key: "olderThanThreeMonthTotalAmount" },
    { label: `Total Receivable Amount (${currency})`, key: "totalAmount" },
  ];

  useEffect(
    () => {
      (async () => {
        getRight();
        await fetchAgedReceivable();
      })();
    },
    [values.sortingType, perPage],
    dispatch
  );
  useEffect(() => {
    fetchData();
  }, [resetClicked, values.sortingType, perPage]);

  const fetchData = async () => {
    if (resetClicked) {
      setResetClicked(false);
      await fetchAgedReceivable();
    }
  };
  const handleDateChange = (date) => {
    values.customDate = date;
    setSelectedDate(date);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      nextFieldRef.current.focus();
    }
  };

  async function getRight() {
    let right = await getScreenRight("Aged Payables Summary");
    console.log("screen_riight", right);
    if (right === "Full Access") {
      setDisableColor(false);
      setScreenAccess(right === "Full Access");
    } else {
      setDisableColor(true);
    }
  }

  // const FilterData = async () => {
  //     await fetchAgedReceivable();
  // }

  const FilterData = async () => {
    await fetchAgedReceivables(
      {
        duration: values.duration,
        agingBy: values.agingBy,
        businessUserID: values.businessUserID,
        page: appConstants.page,
        limit: appConstants.limit,
        customDate: values.customDate,
        sortingType: "",
        sortingField: "",
      },
      (data) => {
        setTotalRows(data.Result_Output.result.totalDocs);
        setRows(data.Result_Output.result.docs);
        setTableData(data.Result_Output.result.docs);
      },
      dispatch
    );
  };

  const ResetData = async () => {
    setValues({
      ...values,
      searchParameter: "",
      duration: "Today",
      agingBy: "dueDate",
      page: appConstants.page,
      limit: appConstants.limit,
      customDate: values.customDate,
      sortingType: "",
      sortingField: "",
      filterValues: "",
    });
    setResetClicked(true);
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };
  const handlePageChange = (page) => {
    values.page = page;
    fetchAgedReceivable();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    setLoading(false);
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    await fetchAgedReceivable();
  };
  // const handleRowSelected = useCallback(state => {
  //     setSelectedRows(state.selectedRows);
  //     if (state.selectedRows.length > 0) {
  //         setTitle(" ");
  //     }
  //     else {
  //         setTitle("");
  //         setDeleteHeading("");
  //     }
  // }, []);
  function exportSwal() {
    setShowModel(false);
    showResMsg(genericMessage.dataExportedSucces, 1000, true);
  }

  const fetchAgedReceivable = async () => {
    await fetchAgedReceivables(
      values,
      (data) => {
        if (data.Result_Output.result.docs.length > 0) {
          setTotalRows(data.Result_Output.result.totalDocs);
          setRows(data.Result_Output.result.docs);
          setTableData(data.Result_Output.result.docs);
        }
      },
      dispatch
    );
  };

  // Give theme color to hide filter --- Starts here

  const { tableBorder } = getColorMappings(sidenavColor);
  // var element = document.getElementsByTagName('fieldset');
  // useEffect(() => {
  //     for (let i = 0; i < element.length; i++) {

  //         if (darkMode) {
  //             element[i].style.borderColor = "white";
  //         } else {
  //             element[i].style.borderColor = tableBorder;
  //         }

  //     }
  // }, [showFilters])
  useEffect(() => {
    var element = document.getElementsByTagName("fieldset");
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    for (let i = 0; i < element.length; i++) {
      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;
    }
  }, [showFilters]);

  useEffect(() => {
    var dropicons = document.querySelectorAll(".MuiInputBase-root");
    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName("svg");
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "");
        }
      }
    }
  }, [showFilters]);

  const reportCol = [
    {
      // name: "Contact Name",
      name: <p style={{ fontSize: "12px" }}>Contact Name</p>,
      selector: (row) =>
        row.contactName === "Total" ? <b>Total</b> : row.contactName,
      sortable: true,
      sortField: "contactName",
    },
    {
      // name: "< 1 Month",
      name: <p style={{ fontSize: "12px" }}>{`< 1 Month`}</p>,
      selector: (row) =>
        row.contactName === "Total" ? (
          <b>{row.lessThanOneMonthTotalAmount}</b>
        ) : (
          row.lessThanOneMonthTotalAmount
        ),
      sortable: true,
      sortField: "lessThanOneMonthTotalAmountToString",
      center: true,
    },
    {
      // name: "1 Month",
      name: <p style={{ fontSize: "12px" }}>1 Month</p>,
      selector: (row) =>
        row.contactName === "Total" ? (
          <b>{row.moreThanOneMonthTotalAmount}</b>
        ) : (
          row.moreThanOneMonthTotalAmount
        ),
      sortable: true,
      sortField: "moreThanOneMonthTotalAmountToString",
      center: true,
    },
    {
      // name: "2 Months",
      name: <p style={{ fontSize: "12px" }}>2 Months</p>,
      selector: (row) =>
        row.contactName === "Total" ? (
          <b>{row.moreThanTwoMonthTotalAmount}</b>
        ) : (
          row.moreThanTwoMonthTotalAmount
        ),
      sortable: true,
      sortField: "moreThanTwoMonthTotalAmountToString",
      center: true,
    },
    {
      // name: "3 Months",
      name: <p style={{ fontSize: "12px" }}>3 Months</p>,
      selector: (row) =>
        row.contactName === "Total" ? (
          <b>{row.moreThanThreeMonthTotalAmount}</b>
        ) : (
          row.moreThanThreeMonthTotalAmount
        ),
      sortable: true,
      sortField: "moreThanThreeMonthTotalAmountToString",
      center: true,
    },
    {
      // name: "Older",
      name: <p style={{ fontSize: "12px" }}>Older</p>,
      selector: (row) =>
        row.contactName === "Total" ? (
          <b>{row.olderThanThreeMonthTotalAmount}</b>
        ) : (
          row.olderThanThreeMonthTotalAmount
        ),
      sortable: true,
      sortField: "olderThanThreeMonthTotalAmountToString",
      center: true,
    },
    {
      // name: `Total Receivable Amount (${currency})`,
      name: (
        <p
          className="payableamount"
          style={{ fontSize: "12px" }}
        >{`Total Receivable Amount (${currency})`}</p>
      ),
      selector: (row) =>
        row.contactName === "Total" ? (
          <b>{formatCurrencyAUD(row.totalAmount)}</b>
        ) : (
          formatCurrencyAUD(row.totalAmount)
        ),
      sortable: true,
      sortField: "totalAmount",
      center: true,
      minWidth: "200px",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Aged Receivables Summary" />
          <Grid
            container
            columnSpacing={2}
            px={2}
            mt={1}
            alignItems="center"
            display="flex"
            justifyContent="right"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.4} gap={0.5}>
              <MDButton
                className={
                  "btn-block center-container-btn btn-warning btn-back rightSpace"
                }
                color={"warning"}
                fullWidth
                onClick={() => {
                  setShowFilters(!showFilters);
                }}
                style={{ height: "38.11px" }}
              >
                {showFilters ? "Hide Filters" : "Set Filters"}
              </MDButton>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.4}>
              {screenAccess ? (
                <MDButton
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  style={{
                    backgroundColor: "#009cff",
                    color: "#ffffff",
                    height: "38.11px",
                  }}
                  fullWidth
                  onClick={() => {
                    setShowModel(true);
                  }}
                >
                  Export
                </MDButton>
              ) : (
                <MDButton
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  style={{ height: "38.11px" }}
                  color={"secondary"}
                  fullWidth
                >
                  Export
                </MDButton>
              )}
            </Grid>
          </Grid>
          {showFilters && (
            <MDBox>
              <Grid item xs={12}>
                <MDBox px={1} pt={1}>
                  <Grid container columnSpacing={2} mx={0.1}>
                    <Grid item xs={12} lg={2.9}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="Duration">Duration</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "38.11px" }}
                            label="Duration"
                            value={values.duration}
                            onChange={handleChange("duration")}
                          >
                            <MenuItem value="Custom"> Custom </MenuItem>
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="EndOfThisMonth">
                              {" "}
                              End of This Month{" "}
                            </MenuItem>
                            <MenuItem value="EndOfLastMonth">
                              {" "}
                              End of Last Month{" "}
                            </MenuItem>
                            <MenuItem value="EndOfLastQuarter">
                              {" "}
                              End of Last Quarter{" "}
                            </MenuItem>
                            <MenuItem value="EndOfLastFinancialYear">
                              {" "}
                              End of Last Financial Year{" "}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={1.6}>
                      {values.duration === "Custom" && (
                        <PickDate
                          selected={selectedDate}
                          onChange={handleDateChange}
                          label="Custom Date"
                          disable={values.duration !== "Custom"}
                          inputProps={{
                            pattern: "^[]+$",
                            maxLength: 30,
                          }}
                          autoComplete="off"
                          maxDate={new Date()}
                          onKeyPress={handleKeyPress}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} lg={1.6}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="agingBy">Aging By</InputLabel>
                          <Select
                            labelId="agingBy-select-label"
                            id="agingBy-select"
                            style={{ height: "38.11px" }}
                            label="Aging By"
                            value={values.agingBy}
                            // onChange={handleChange('reminderStatus')}
                            onChange={(e) =>
                              setValues({ ...values, agingBy: e.target.value })
                            }
                          >
                            <MenuItem value="dueDate"> Due Date </MenuItem>
                            <MenuItem value="invoiceDate">
                              {" "}
                              Invoice Date{" "}
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.9}>
                      <ClearableSearchField
                        type="text"
                        label="Search"
                        variant="outlined"
                        fullWidth
                        className="searchButton"
                        placeholder="Search..."
                        size="medium"
                        autoComplete="off"
                        value={values.filterValues}
                        onChange={handleSearchFilter}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") fetchAgedReceivable();
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <Button
                                style={{
                                  borderRadius: "3px 0.3rem  0.3rem 0px",
                                  boxShadow: "none",
                                  background: barColor,
                                }}
                                variant="contained"
                                onClick={fetchAgedReceivable}
                              >
                                <GridSearchIcon color="white" />
                              </Button>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} ml={0.6} spacing={2} lg={1.3}>
                      {/* <Link to={"/ClientReport"}> */}
                      <MDButton
                        className="btn-block center-container-btn btn-warning btn-back rightSpace"
                        color="warning"
                        fullWidth
                        onClick={ResetData}
                        style={{ height: "38.11px" }}
                      >
                        Reset
                      </MDButton>
                    </Grid>
                    <Grid item xs={12} spacing={2} lg={1.3}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                        onClick={FilterData}
                        style={{ height: "38.11px" }}
                      >
                        Apply
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </MDBox>
          )}
          {/* <CardContent> */}
          <BTable
            columns={reportCol}
            data={rows}
            loading={loading}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            // onSelectedRowsChange={handleRowSelected}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>

        {showModel && (
          <Modal
            open={showModel}
            onClose={() => setShowModel(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ fontSize: "40px", textAlign: "center" }}
                >
                  <HelpIcon style={{ color: "red" }} />
                </Typography>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ color: "black" }}
                >
                  Would you like to export this record?
                </Typography>
                <Grid
                  container
                  id="modal-modal-description"
                  sx={{ mt: 2, justifyContent: "center" }}
                >
                  <>
                    <MDButton
                      className="no-button"
                      onClick={() => {
                        setShowModel(false);
                      }}
                      sx={{ width: "64px", textTransform: "capitalize" }}
                    >
                      No
                    </MDButton>
                  </>
                  &nbsp; &nbsp;
                  <>
                    <CSVLink
                      data={tabledata}
                      headers={headers}
                      filename={
                        "Aged Receivables Summary (" +
                        new Date().toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        }) +
                        ") .csv"
                      }
                    >
                      <MDButton
                        className="yes-button"
                        onClick={() => {
                          exportSwal();
                        }}
                        sx={{ width: "64px", textTransform: "capitalize" }}
                      >
                        Yes
                      </MDButton>
                    </CSVLink>
                  </>
                </Grid>
              </Box>
            </Card>
          </Modal>
        )}
        <LoadingModal loading={false} />
      </div>
    </DashboardLayout>
  );
}
export default AgedReceivables;
